
import {defineComponent} from "vue";
import LoginForm from "@/components/User/LoginForm.vue";

export default defineComponent({
  name: 'Login',
  components: {LoginForm},
})
